export default __webpack_public_path__ + "static/headless-checkout-ef421a7ad03a98783dbb556671695018.png";